import { uri } from '../../api-endpoint';
import {
  IProjectAPIValidationError,
  IProjectFromAPISuccessResponse
} from '../../type-conversion/project/from-api-repsonse';
import { createTemplateFn } from '../common';

export const approveProject = (token: string) => (projectId: number) =>
  createTemplateFn(
    token,
    uri.projectApprove(projectId),
    () => ({}),
    IProjectFromAPISuccessResponse,
    IProjectAPIValidationError
  );
